import React from 'react';
import { Select, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

/**
 * 언어 전환 컴포넌트
 * 
 * 사용자가 한국어와 영어 간에 언어를 전환할 수 있는 컴포넌트입니다.
 */
const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <Space>
      <GlobalOutlined />
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        style={{ width: 100 }}
        size="small"
      >
        <Option value="ko">한국어</Option>
        <Option value="en">English</Option>
      </Select>
    </Space>
  );
};

export default LanguageSwitcher; 